import "./EligibilityCheckerRoot.scss";

import { MemoryRouter, Route, Switch } from "react-router";
import { useSelector } from "react-redux";
import {
  LandingPage,
  PostcodeCheckerRoot,
  AgeCheckerRoot,
  SexCheckerRoot,
  PhysicalHealthRoot,
  MentalHealthRoot,
  DisabilitiesRoot,
  IntroduceYourself,
  ContactNumber,
  OysHeadOfServiceRoot,
  AlmostDone,
} from "../../EligibilityCheckerGeneric";
import { getLatestProfileJourneyLocal } from "../../EligibilityCheckerGeneric/helpers";
import { Ethnicity, BmiRoot, Pathway } from "..";
import { ModalPageBackground } from "../../../organisms/ModalPage";
import PageBg from "../../../../assets/img/bg/eligibilityCheckerBg.png";
import { Pages } from "../../../../data/eligibilityChecker/loseWeight/pages";
import { loseWeightPageTitle } from "../../../../data/Programme";
import { programmes } from "../../../../enums/programmes";
import { useEffect, useState } from "react";
import { Journey } from "../../../../types/ProfileViewModel";
import useUserId from "../../../hooks/useUserId";
import { useGetProfileByIdQuery } from "../../../../redux/profileApiV3";

const EligibilityCheckerRoot = () => {
  const [latestJourney, setLatestJourney] = useState<Journey | null>(null);
  const signupFlowData = useSelector((state: any) => state.signupFlowData);
  const postcodePageData = Pages.postcodeChecker;
  const [userId] = useUserId();
  const { data: profile } = useGetProfileByIdQuery(userId);

  useEffect(() => {
    if (!profile) {
      return;
    }
    const latestJourneyLocal = getLatestProfileJourneyLocal(profile);
    setLatestJourney(latestJourneyLocal);
  }, [profile]);

  return (
    <ModalPageBackground className="eligibility-checker-page" bgImage={PageBg}>
      <MemoryRouter>
        <Switch>
          <Route exact path={"/"}>
            <LandingPage
              landingPageData={signupFlowData.data.landingPage}
              programmeTitle={loseWeightPageTitle}
              nextStepUrl="/postcode"
              errorMessage={signupFlowData.error?.message}
              hasError={signupFlowData.errorStatus}
              isLoading={signupFlowData.loading}
              progressPercentage={0}
            />
          </Route>
          <Route path={"/postcode"}>
            <PostcodeCheckerRoot
              postcodePageData={postcodePageData}
              programmeTitle={loseWeightPageTitle}
              nextStepUrl="/age"
              programmeId={programmes["lose-weight"].id}
              progressPercentage={10}
              existingPostcode={latestJourney?.postcode}
            />
          </Route>
          <Route path={"/age"}>
            <AgeCheckerRoot
              programmeTitle={loseWeightPageTitle}
              pageData={Pages.age}
              existingDob={new Date(profile?.personalDetails?.dateOfBirth)}
              progressPercentage={20}
            />
          </Route>
          <Route path={"/sex"}>
            <SexCheckerRoot
              progressPercentage={30}
              sex={profile?.personalDetails.birthSex}
              gender={profile?.personalDetails.gender}
              genderIsBirthSex={profile?.personalDetails.genderIsBirthSex}
              isPregnant={latestJourney?.isPregnant}
              isBreastFeeding={latestJourney?.isBreastFeeding}
              programmeTitle={loseWeightPageTitle}
            />
          </Route>
          <Route path={"/physical-health"}>
            <PhysicalHealthRoot
              healthConditions={latestJourney?.healthConditions}
              programmeTitle={loseWeightPageTitle}
              physicalHealthPageData={Pages.physicalHealth}
              nextStepUrl="/mental-health"
            />
          </Route>
          <Route path={"/mental-health"}>
            <MentalHealthRoot
              healthConditions={latestJourney?.healthConditions}
              programmeTitle={loseWeightPageTitle}
              mentalHealthPageData={Pages.mentalHealth}
              nextStepUrl="/disabilities"
              progressPercentage={40}
            />
          </Route>
          <Route path={"/disabilities"}>
            <DisabilitiesRoot
              disabilities={latestJourney?.healthConditions?.disabilities}
              programmeTitle={loseWeightPageTitle}
              disabilitiesPageData={Pages.disabilities}
              nextStepUrl="/ethnicity"
              progressPercentage={50}
            />
          </Route>
          <Route path={"/ethnicity"}>
            <Ethnicity ethnicity={profile?.ethnicity} progressPercentage={60} />
          </Route>
          <Route path={"/bmi"}>
            <BmiRoot
              programmeTitle={loseWeightPageTitle}
              height={latestJourney?.height}
              weight={latestJourney?.weight}
            />
          </Route>
          <Route path={"/pathway"}>
            <Pathway progressPercentage={70} />
          </Route>
          <Route path={"/introduce-yourself"}>
            <IntroduceYourself
              programmeTitle={loseWeightPageTitle}
              profileFirstName={profile?.personalDetails.firstName}
              profileLastName={profile?.personalDetails.lastName}
            />
          </Route>
          <Route path={"/contact-number"}>
            <ContactNumber
              programmeTitle={loseWeightPageTitle}
              profilePhoneNumber={profile?.personalDetails.phoneNumber}
            />
          </Route>
          <Route path={"/oys-head-of-service"}>
            <OysHeadOfServiceRoot programmeTitle={loseWeightPageTitle} progressPercentage={80} />
          </Route>

          <Route path={"/almost-done"}>
            <AlmostDone
              programmeTitle={loseWeightPageTitle}
              programmeSlug="lose-weight"
              progressPercentage={90}
              profileBuilderUrl="/sign-up/profile-builder"
            />
          </Route>
        </Switch>
      </MemoryRouter>
    </ModalPageBackground>
  );
};



export default EligibilityCheckerRoot;


